/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_NlInputs */

const en_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const es_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const de_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const zh_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const ar_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const fr_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const vi_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const sw_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const th_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const bs_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const ja_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const ko_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const pt_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const it_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const sv_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const nl_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const da_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const nb_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const fi_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const pl_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const ru_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const tr_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const hi_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const id_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const ms_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const cs_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const el_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const he_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const af_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

const hu_nav_language_nl = /** @type {(inputs: Nav_Language_NlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nederlands`)
};

/**
* | output |
* | --- |
* | "Nederlands" |
*
* @param {Nav_Language_NlInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_nl = /** @type {((inputs?: Nav_Language_NlInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_NlInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_nl(inputs)
	if (locale === "de") return de_nav_language_nl(inputs)
	if (locale === "zh") return zh_nav_language_nl(inputs)
	if (locale === "ar") return ar_nav_language_nl(inputs)
	if (locale === "fr") return fr_nav_language_nl(inputs)
	if (locale === "vi") return vi_nav_language_nl(inputs)
	if (locale === "sw") return sw_nav_language_nl(inputs)
	if (locale === "th") return th_nav_language_nl(inputs)
	if (locale === "bs") return bs_nav_language_nl(inputs)
	if (locale === "ja") return ja_nav_language_nl(inputs)
	if (locale === "ko") return ko_nav_language_nl(inputs)
	if (locale === "pt") return pt_nav_language_nl(inputs)
	if (locale === "it") return it_nav_language_nl(inputs)
	if (locale === "sv") return sv_nav_language_nl(inputs)
	if (locale === "nl") return nl_nav_language_nl(inputs)
	if (locale === "da") return da_nav_language_nl(inputs)
	if (locale === "nb") return nb_nav_language_nl(inputs)
	if (locale === "fi") return fi_nav_language_nl(inputs)
	if (locale === "pl") return pl_nav_language_nl(inputs)
	if (locale === "ru") return ru_nav_language_nl(inputs)
	if (locale === "tr") return tr_nav_language_nl(inputs)
	if (locale === "hi") return hi_nav_language_nl(inputs)
	if (locale === "id") return id_nav_language_nl(inputs)
	if (locale === "ms") return ms_nav_language_nl(inputs)
	if (locale === "cs") return cs_nav_language_nl(inputs)
	if (locale === "el") return el_nav_language_nl(inputs)
	if (locale === "he") return he_nav_language_nl(inputs)
	if (locale === "af") return af_nav_language_nl(inputs)
	if (locale === "hu") return hu_nav_language_nl(inputs)
	return en_nav_language_nl(inputs)
});